import { render } from "./PattanModal.vue?vue&type=template&id=5e1d5e46&scoped=true"
import script from "./PattanModal.vue?vue&type=script&lang=js"
export * from "./PattanModal.vue?vue&type=script&lang=js"

import "./PattanModal.vue?vue&type=style&index=0&id=5e1d5e46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1d5e46"]])

export default __exports__